import React from 'react';
import Loader from 'react-loaders';
// import '~loaders.css/src/animations/ball-scale-multiple.scss';

const Loading = ({loading}) => {
  return <Loader type="ball-pulse" active={loading} />
}

export default Loading


// WEBPACK FOOTER //
// ./src/components/Loading.js